module.exports = __webpack_public_path__ + "966c34b96e1b3f3e732cfd4bf95bc81d.png";